/* eslint-disable import/prefer-default-export */
export var TRANSITION_DURATION = 320;